import { __assign } from "tslib";
// DS: i8.9
import React from 'react';
import IconWrap from '../../IconWrap';
var Block = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("path", { fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4 9H8a1 1 0 00-.117 1.993L8 13h8a1 1 0 00.117-1.993L16 11z" })))); };
Block.displayName = 'Block';
export default Block;
//# sourceMappingURL=Block.js.map